import { SeatResponse, originSeat, NewSeat } from '@/api/modules/seat/interface';
import {  CheckCN } from '@/utils/lang';
/**
 * 根据计算座位信息
 */
const calculateSeatInfo = (oldSeats: originSeat[]): originSeat[][] => {
  let seats = JSON.parse(JSON.stringify(oldSeats));
  // let seats=oldSeats
  // 第一步：座位改成数组[[第一行],[第二行],[第三行]]
  let newTmplSeats: any = [];
  let tmpObj = {};
  let left: number = 1000; // 顺便计算left
  seats.forEach((item) => {
    if (item.seatX < left) {
      left = item.seatX;
    }
    let arr = tmpObj[item.seatY];
    if (arr) {
      arr.push(item);
    } else {
      // 不存在
      arr = [item];
    }
    tmpObj[item.seatY] = arr;
  });
  // 去除 空的整行
  Object.keys(tmpObj).forEach((k) => {
    newTmplSeats.push(tmpObj[k]);
  });
  // 必须洗一下数据。 升序排列
  newTmplSeats.forEach((arr) => {
    var v = arr.sort((x, y) => x.seatX - y.seatX);
  });
  // console.log(newTmplSeats,'---');
  let prevItem = newTmplSeats[0][0];
  let curMaxColumn = 0; //当前行最大的座位数
  let maxColumn = 0; //一行最大的座位数
  let row = 1; // 行数
  let columnWidth = 10000; // 只计算 3* 3
  let rowHeight = 10000;
  let top = prevItem.seatY; // top

  // 第二步： 计算 间距x
  newTmplSeats.forEach((itemArr) => {
    itemArr.forEach((item, idx) => {
      if (item.seatY === prevItem.seatY) {
        let x = Math.abs(item.seatX - prevItem.seatX);
        columnWidth = x > 0 && x < columnWidth ? x : columnWidth;
        if (idx !== 0) {
          prevItem = itemArr[idx];
        }
      } else {
        prevItem = item;
      }
    });
  });
  // min
  let minSeat;
  // 计算最大行数
  newTmplSeats.forEach((itemArr) => {
    if (!minSeat || itemArr[0].seatX < minSeat.seatX) {
      minSeat = itemArr[0];
    }
  });
  // 计算最大行数
  newTmplSeats.forEach((itemArr) => {
    const length = itemArr.length;
    let maxIndex = length - 1;
    curMaxColumn = Math.abs(itemArr[maxIndex].seatX - minSeat.seatX) / columnWidth + 1;
    if (maxColumn < curMaxColumn) {
      maxColumn = curMaxColumn;
    }
  });

  row = newTmplSeats.length;
  // console.log(newTmplSeats);

  let newSeats: Array<Array<originSeat>> = [];
  for (let i = 0; i < row; i++) {
    let a: any = [];
    let s = newTmplSeats[i]; // 第一行
    let t = 0;
    let item = s[t]; // 行的第一个数据

    for (let j = 0; j < maxColumn; j++) {
      let tar = left + columnWidth * j;
      if (!item || item.seatX !== tar) {
        let tmpS: any = getTmplSeat();
        tmpS.seatX = j + 1;
        tmpS.seatY = i + 1;
        a.push(tmpS);
      } else {
        item.seatX = j + 1;
        item.seatY = i + 1;
        a.push(item);
        t++;
        item = s[t];
      }
    }
    newSeats.push(a);
  }
  return newSeats;
  // return {
  //   map: { row, column: maxColumn },
  //   seat: { width: columnWidth, height: rowHeight, left, top },
  //   targetData: newSeats,
  // }
};

const getTmplSeat = (): originSeat => ({
  seatDesc: '',
  seatType: 1,
  seatX: 0,
  seatY: 0,
  sectionId: '',
  status: 2,
  vendorSeatDesc: ''
});
function fn(arr) {
  return arr.reduce((prev, cur) => prev.concat(Array.isArray(cur) ? fn(cur) : cur), []);
}
/**
 * 获取座位价格
 */
const getSeatPriceInfo = (
  prices: any,
  seat: any,
  isMul: boolean = true,
): { sp: any; spid: number } => {
  let spItem;
  if (isMul) {
    // 多票价
    spItem = prices.find((item) => item.id == seat.sectionId);
    // 做一下兼容。
    spItem = spItem || prices[0];
  } else {
    // 单票价
    spItem = prices[0];
  }
  const idx: number = prices.findIndex((item) => item.id == seat.sectionId) || 0;
  return { sp: spItem, spid: idx };
};
// 根据 选中的座位，获取 分区价格 数组 [{price:100,count:1},{price:200,count:3}]
const getSelectSeatSectionPrices = (selSeat: any) => {
  let res = [];
  selSeat.forEach((selItem) => {
    let obj = res.find((item) => item.price == selItem.price);
    if (obj) {
      obj.count++;
    } else {
      obj = { price: selItem.price, count: 1 };
      res.push(obj);
    }
  });
  // console.log('res', res);
  return res;
};
/**
 * 分区价格转换, 价格升序排序
 */
const getPriceArr = (prices: any): any => {
  let arr = new Array();
  prices.forEach((item) => {
    arr.push(item.price);
  });
  return arr;
};
const switchSeatType = (st: number, s: number): number => {
  let res; // 0 走廊， 1 可售， 4 已售(可分左右) 5 可售情侣
  switch (st) {
    case 1: //1-走廊
      // 1-可售 2-不可售
      res = 0;
      break;
    case 2: //2-普通座位
      s === 1 ? (res = 1) : (res = 4);
      break;
    case 3: // 3-残疾人座
      // res = 4; //  新增加残疾人座，按照已售展示 (2021-07-13 注释掉了)
      s === 1 ? (res = 1) : (res = 4);
      break;
    case 4: // 4-情侣左座
      s === 1 ? (res = 5) : (res = 401);
      break;
    case 5: //5-情侣右座
      s === 1 ? (res = 5) : (res = 402);
      break;
    default:
      res = 0;
  }
  return res;
};
// 多票价  (座位类型，座位状态， 票价分区ID)
const switchMultiSeatType = (st: number, s: number, sid: number): number => {
  // 颜色兜底操作（座位图）

  // const sectId = sid>=multiPriceColor.length?multiPriceColor.length:sid
  let res: number;
  switch (st) {
    case 1: //1-走廊 不显示
      // 1-可售 2-不可售
      res = 0;
      break;
    case 2: //2-普通座位
      if (s == 1) {
        // 可售
        res = 1 * 100 + sid;
      } else {
        // 已售
        res = 4;
      }
      break;
    case 3: // 3-残疾人座
      // res = 4;
      if (s == 1) {
        // 可售
        res = 1 * 100 + sid;
      } else {
        // 已售
        res = 4;
      }
      break;
    case 4: // 4-情侣左座
      // s === 1 ? res=5: res=7; break;
      if (s == 1) {
        // 可售
        res = 5 * 100 + sid;
      } else {
        // 已售
        res = 401;
      }
      break;
    case 5: //5-情侣右座
      // s === 1 ? res=5: res=7; break;
      if (s == 1) {
        // 可售
        res = 5 * 100 + sid;
      } else {
        // 已售
        res = 402;
      }
      break;
    default:
      res = 0;
  }
  return res;
};

/**
 * 转换座位图
 */
const translateOnlineSeatToLocal = (
  res: SeatResponse,
  // useRowColumn: boolean,
  isMul: boolean,
  selSeats: any=[]
): Array<Array<NewSeat>> => {
  let info: originSeat[][];
  // if (useRowColumn === false) {
  //   // 这里使用 坐标
  //   info = calculateSeatInfo_PX(res.seats)
  // } else {
  // 使用行列
  if (!res.seats) {
    return [];
  }
  info = calculateSeatInfo(res.seats);
  // }
  // console.log('info', info);
  let seats: Array<Array<NewSeat>> = [];
  info.forEach((items: any) => {
    let tmpArr: Array<NewSeat> = [];
    items.forEach((item: any) => {
      const { sp, spid } = getSeatPriceInfo(res.sectionPrices, item, isMul);
      // 根据 座位状态和分区 id 转换为 新的座位状态
      const state = isMul
        ? switchMultiSeatType(item.seatType, item.status, spid + 1)
        : switchSeatType(item.seatType, item.status);
      const isSelected = selSeats?.find((t) => t.vendorSeatId===item.vendorSeatId);
      const seat: NewSeat = {
        id: `${item.seatX}-${item.seatY}`,
        state:isSelected?isSelected.state: state, // 转后后的新座位状态
        originState: isSelected?isSelected.state:state, // 转后后的新座位状态
        seatEnDesc:item.seatEnDesc,
        floorId: item.floorId,
        seatDesc:item.seatDesc,
        info: CheckCN()?item.seatDesc:item?.seatEnDesc,
        vendorSeatDesc: item.vendorSeatDesc,
        price: sp.price,
        vendorSeatId: item.vendorSeatId,
        // eslint-disable-next-line comma-dangle
        sectionId: item.sectionId,
      };
      tmpArr.push(seat);
    });
    seats.push(tmpArr);
  });
  // console.log('seats', seats);
  return seats;
};
const getTotalPrice = (arr: any) => {
  if (typeof arr === 'undefined' || arr.length === 0) {
    return 0;
  }
  let total = 0;
  arr.forEach((item: any) => {
    total += item.price;
  });

  return total;
};
/**
 * 定义多票价色值 定义10中颜色
 *
 */
const multiPriceColor = [
  {
    color: 'rgba(229,147,151,1)',
    bgColor: 'rgba(229,147,151,0.1)'
  },
  {
    color: 'rgba(230,183,155,1)',
    bgColor: 'rgba(230,183,155,0.1)'
  },
  {
    color: 'rgba(215,187,129,1)',
    bgColor: 'rgba(215,187,129,0.1)'
  },
  {
    color: 'rgba(152,206,189,1)',
    bgColor: 'rgba(152,206,189,0.1)'
  },
  {
    color: 'rgba(153,208,240,1)',
    bgColor: 'rgba(153,208,240,0.1)'
  },
  {
    color: 'rgba(179,182,239,1)',
    bgColor: 'rgba(179,182,239,0.1)'
  },
  {
    color: 'rgba(194,166,207,1)',
    bgColor: 'rgba(194,166,207,0.1)'
  },
  {
    color: 'rgba(178,178,178,1)',
    bgColor: 'rgba(178,178,178,0.1)'
  }
];

/**
 * 校验座位是否可购买。防止空座
 * true 可购买。 false 不可购买
 */
const verifiedSeatForPurchase = (seats: NewSeat[][]): boolean => {
  // 遍历数组
  const hasSelSeats = seats.filter((seatArr) => seatArr.some((s) => isSelectedSeat(s)));

  return hasSelSeats.every((seatArr) =>
    // 找到一排中 选中的座位
    seatArr.every((s, index) => {
      if (isSelectedSeat(s)) {
        const length = seatArr.length;
        // 选中的座位
        let prevIndex = index - 1;
        let prevIndex2 = index - 2;
        let nextIndex = index + 1;
        let nextIndex2 = index + 2;
        if (prevIndex < 0 || nextIndex >= length) {
          // 表示该座位是第一个或者最后一个。 可以购买
          return true;
        }
        // 左右都存在1+个座位. 判断左右状态
        const prevSeat = seatArr[prevIndex];
        const nextSeat = seatArr[nextIndex];
        // checkAvailableSeat == true  可选的
        const prevSeatStatus = checkAvailableSeat(prevSeat);
        const nextSeatStatus = checkAvailableSeat(nextSeat);
        if (!prevSeatStatus || !nextSeatStatus) {
          // 前一个或者后一个 状态 是不可购买， 说明该座位可购买
          return true;
        }
        // if (prevIndex2 < 0 || nextIndex2 >= length) {
        //   // 前一个且后一个是可购买。 前第2个或后第2个 不存在。说明空一个可选座位
        //   return false
        // }
        const prevSeat2 = seatArr[prevIndex2];
        const nextSeat2 = seatArr[nextIndex2];
        const prevSeatStatus2 = checkAvailableSeat(prevSeat2);
        const nextSeatStatus2 = checkAvailableSeat(nextSeat2);

        // 左边第二个不存在，且左边可选
        if (!prevSeat2 && !isSelectedSeat(prevSeat) && !isSelectedSeat(nextSeat)) {
          return false;
        }
        // 右边第二个不存在，且右边可选
        if (!nextSeat2 && !isSelectedSeat(nextSeat) && !isSelectedSeat(prevSeat)) {
          return false;
        }
        // 左边第二个存在 且不可选 且为过道 且左边第一个可选
        if (
          prevSeat2 &&
          !prevSeatStatus2 &&
          prevSeat2.originState === 0 &&
          !isSelectedSeat(prevSeat)
        ) {
          return false;
        }
        // 左第2个是不可购买且 右边为可选
        if (
          prevSeat2 &&
          !prevSeatStatus2 &&
          !isSelectedSeat(nextSeat) &&
          !isSelectedSeat(prevSeat)
        ) {
          return false;
        }
        // 右第2个是不可购买且是过道 且 右边第一个可选
        if (
          nextSeat2 &&
          !nextSeatStatus2 &&
          nextSeat2.originState === 0 &&
          !isSelectedSeat(nextSeat)
        ) {
          return false;
        }
        // 右第2个是不可购买且左边是可选
        if (
          nextSeat2 &&
          !nextSeatStatus2 &&
          nextSeat2.originState !== 0 &&
          !isSelectedSeat(prevSeat) &&
          !isSelectedSeat(nextSeat)
        ) {
          return false;
        }
        // 右第2个是不可购买且左边是可选
        if (
          nextSeat2 &&
          !nextSeatStatus2 &&
          nextSeat2.originState !== 0 &&
          !isSelectedSeat(prevSeat) &&
          !isSelectedSeat(nextSeat)
        ) {
          return false;
        }
        // 左边第二个选中，左边第一个可选
        if (isSelectedSeat(prevSeat2) && !isSelectedSeat(prevSeat)) {
          return false;
        }
        // 右边第2个选中，且 右边是可选
        if (isSelectedSeat(nextSeat2) && !isSelectedSeat(nextSeat)) {
          return false;
        }
        // 右边遍历校验 最右边第一个为可选。最右边第二个 过道/已售
        if (checkConsecutiveSeat(seatArr, index) === false) {
          return false;
        }
        return true;
      } else {
        return true;
      }
    }),
  );
};
const isSelectedSeat = (s: NewSeat) => {
  if (!s) {
    return false;
  }
  return s.state !== s.originState;
};
const checkAvailableSeat = (seat: NewSeat) => {
  if (!seat) {
    return false;
  }
  // 0 , 4  401 402  都是不售
  if (
    seat.originState === 0 ||
    seat.originState === 4 ||
    (seat.originState > 400 && seat.originState < 500)
  ) {
    return false;
  }
  return true;
};
// true 后面2个以上可选，
const checkConsecutiveSeat = (seats: NewSeat[], index): boolean => {
  let prev = true; // 前面通过校验
  let next = true; // 后面通过校验
  const length = seats.length;
  let hasBoundary = false; // 左右边存在边界

  if (index == 0 || index === length - 1) {
    hasBoundary = true;
  }
  let prevs = seats[index - 1];
  let nexts = seats[index + 1];
  if (checkAvailableSeat(prevs) === false || checkAvailableSeat(nexts) === false) {
    hasBoundary = true;
  }

  for (let idx = index; idx < length; idx++) {
    let curS = seats[idx];
    let nextS = seats[idx + 1];
    if (isSelectedSeat(curS) && !checkAvailableSeat(nextS)) {
      hasBoundary = true;
    }
  }
  for (let idx = index; idx > 0; idx--) {
    let curS = seats[idx];
    let prevS = seats[idx - 1];
    if (isSelectedSeat(curS) && !checkAvailableSeat(prevS)) {
      hasBoundary = true;
    }
  }
  if (hasBoundary) {
    return true;
  }
  for (let idx = 0; idx < length; idx++) {
    if (!isSelectedSeat(seats[idx]) && idx < index - 1) {
      continue;
    }
    if (idx === index - 1 && !isSelectedSeat(seats[index - 1])) {
      // 当前的前一个座位为可选   判断 index-2
      if (index - 2 >= 0 && checkAvailableSeat(seats[index - 2])) {
        // 存在 & 可选
        prev = true;
      } else {
        prev = false;
      }
    } else if (idx === index - 1 && isSelectedSeat(seats[index - 1])) {
      prev = true;
    }
    if (idx < index) {
      continue;
    }
    // 当前的后一个
    if (idx + 1 >= length) {
      hasBoundary = true;
      next = true;
      break;
    }
    let s = seats[idx + 1];
    if (checkAvailableSeat(s) === false) {
      hasBoundary = true;
      next = true;
      break;
    }
    if (isSelectedSeat(s)) {
      continue;
    }
    // 当前的后一个
    if (idx + 2 >= length) {
      next = false;
      break;
    }
    let s2 = seats[idx + 2];
    if (checkAvailableSeat(s2) === false) {
      next = false;
      break;
    } else {
      next = true;
      break;
    }
  }
  if (hasBoundary) {
    return true;
  }
  if (prev && next) {
    return true;
  }
  return false;
};

export {
  verifiedSeatForPurchase,
  translateOnlineSeatToLocal,
  calculateSeatInfo,
  getSeatPriceInfo,
  getPriceArr,
  switchSeatType,
  getTotalPrice,
  multiPriceColor,
  getSelectSeatSectionPrices
};
